export const LANGUAGES = [
  "Afrikaans",
  "Amharic",
  "Arabic",
  "Azerbaijani",
  "Byelorussian",
  "Bulgarian",
  "Bengali,Bangla",
  "Bosnian",
  "Catalan",
  "Cebuano",
  "Corsican",
  "Czech",
  "Welsh",
  "Danish",
  "German",
  "Greek",
  "English",
  "Esperanto",
  "Spanish",
  "Estonian",
  "Basque",
  "Persian",
  "Finnish",
  "French",
  "Frisian",
  "Irish",
  "Gaelic (Scots Gaelic)",
  "Galician",
  "Gujarati",
  "Hausa",
  "Hindi",
  "Hmong",
  "Croatian",
  "Haitian Creole",
  "Hungarian",
  "Armenian",
  "Indonesian",
  "Igbo",
  "Icelandic",
  "Italian",
  "Hebrew",
  "Japanese",
  "Javanese",
  "Georgian",
  "Kazakh",
  "Cambodian",
  "Kannada",
  "Korean",
  "Kurdish",
  "Kirghiz",
  "Latin",
  "Luxembourgish",
  "Laothian",
  "Lithuanian",
  "Latvian,Lettish",
  "Malagasy",
  "Maori",
  "Macedonian",
  "Malayalam",
  "Mongolian",
  "Marathi",
  "Malay",
  "Maltese",
  "Burmese",
  "Nepali",
  "Dutch",
  "Norwegian",
  "Nyanja",
  "Punjabi",
  "Polish",
  "Pashto,Pushto",
  "Portuguese",
  "Romanian",
  "Russian",
  "Sindhi",
  "Singhalese",
  "Slovak",
  "Slovenian",
  "Samoan",
  "Shona",
  "Somali",
  "Albanian",
  "Serbian",
  "Sesotho",
  "Sundanese",
  "Swedish",
  "Swahili",
  "Tamil",
  "Tegulu",
  "Tajik",
  "Thai",
  "Turkish",
  "Ukrainian",
  "Urdu",
  "Uzbek",
  "Vietnamese",
  "Xhosa",
  "Yiddish",
  "Yoruba",
  "Chinese",
  "Zulu",
];
